<template>
  <v-layout column>
    <v-toolbar flat dark color="primary">
      <v-toolbar-title>
        <span class="headline" v-if="this.editMode">Редактирование акции</span>
        <span class="headline" v-else>Новая акция</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn icon dark @click="cancelPromotion">
          <v-icon>{{ icons.close }}</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-form ref="form" v-model="valid">
      <v-card>
        <v-card-title></v-card-title>

        <v-card-text>
          <v-container>
            <v-autocomplete
              clearable
              label="Тип клиента"
              v-model.trim="promotionModel.organizationTypeId"
              :items="organizationTypes"
              item-text="type"
              item-value="organizationTypeId"
            ></v-autocomplete>

            <v-autocomplete
              clearable
              label="Клиент"
              v-model.trim="promotionModel.organizationId"
              :items="filteredOrganizations"
              item-text="name"
              item-value="id"
            >
            </v-autocomplete>

            <v-text-field
              label="Название (если не введено, будет использоваться имя файла)"
              placeholder="Название акции"
              v-model.trim="promotionModel.name"
            ></v-text-field>

            <v-layout align-center>
              <v-flex>
                <v-menu
                  offset-y
                  transition="scale-transition"
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      readonly
                      clearable
                      v-on="on"
                      label="Дата начала акции"
                      v-model.trim="promotionModel.start"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    color="secondary"
                    v-model.trim="promotionModel.start"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex>
                <v-icon class="mx-1">{{ icons.arrowLeftRight }}</v-icon>
              </v-flex>
              <v-flex>
                <v-menu
                  offset-y
                  transition="scale-transition"
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      readonly
                      clearable
                      v-on="on"
                      label="Дата завершения акции"
                      v-model.trim="promotionModel.end"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    color="secondary"
                    v-model.trim="promotionModel.end"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>

            <span v-if="this.editMode">
              Файл акции
              <a
                class="text-no-decoration"
                target="_blank"
                :href="promotionModel.link"
                >{{ promotionModel.name }}</a
              >
            </span>

            <v-file-input
              outlined
              accept=".doc,.docx,.xml,.xls,.xlsx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              placeholder="Выберите файл с акциями"
              :prepend-icon="icons.paperclip"
              label="Файл с акциями"
              v-model="promotionModel.file"
              v-else
            >
            </v-file-input>
          </v-container>
          <!-- <small>*указывает на обязательное поле</small> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined color="primary" @click="cancelPromotion"
            >Отмена</v-btn
          >
          <v-btn dark color="primary" @click="savePromotion">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-layout>
</template>

<script>
import { Icon } from "@/helpers";

export default {
  props: {
    organizations: {
      type: Array,
      required: true,
    },
    promotion: {
      type: Object,
      required: true,
    },
  },
  computed: {
    editMode: function () {
      return this.promotion.promotionId != null;
    },
    organizationTypes: function () {
      return this.organizations
        .map((x) => ({
          organizationTypeId: x.organizationTypeId,
          type: x.type,
        }))
        .filter((value, index, self) => {
          return (
            self
              .map((x) => x["organizationTypeId"])
              .indexOf(value["organizationTypeId"]) === index
          );
        });
    },
    filteredOrganizations: function () {
      return this.organizations &&
        this.organizations != null &&
        this.promotionModel.organizationTypeId &&
        this.promotionModel.organizationTypeId != null &&
        this.promotionModel.organizationTypeId != ""
        ? this.organizations.filter((item) => {
            return (
              item.organizationTypeId == this.promotionModel.organizationTypeId
            );
          })
        : this.organizations;
    },
  },
  watch: {
    promotion: async function (value) {
      await this.init();
    },
  },
  methods: {
    init: async function () {
      if (this.promotion && this.promotion != null) {
        this.promotionModel = {
          promotionId: this.promotion.promotionId,
          organizationTypeId: this.promotion.organizationTypeId,
          organizationId: this.promotion.organizationId,
          name: this.promotion.name,
          start: this.$dayjs(this.promotion.start).format("YYYY-MM-DD"),
          end: this.$dayjs(this.promotion.end).format("YYYY-MM-DD"),
          link: this.promotion.link,
        };
      }
    },
    clearPromotionModel: function () {
      this.promotionModel = {
        organizationTypeId: "",
        organizationId: "",
        name: "",
        start: "",
        end: "",
        file: [],
      };
    },
    cancelPromotion: function () {
      this.$emit("cancel-promotion");
      // this.clearPromotionModel();
    },
    savePromotion: function () {
      if (
        this.promotionModel &&
        this.promotionModel != null &&
        this.promotionModel.organizationTypeId === undefined
      ) {
        this.promotionModel.organizationTypeId = "";
      }

      if (
        this.promotionModel &&
        this.promotionModel != null &&
        this.promotionModel.organizationId === undefined
      ) {
        this.promotionModel.organizationId = "";
      }

      this.$emit("save-promotion", this.promotionModel);

      this.clearPromotionModel();
    },
  },
  data: () => ({
    valid: true,
    promotionModel: {
      promotionId: "",
      organizationTypeId: "",
      organizationId: "",
      name: "",
      start: "",
      end: "",
      file: [],
      link: "",
    },
    icons: {
      arrowLeftRight: Icon.arrowLeftRight,
      close: Icon.close,
      paperclip: Icon.paperclip,
    },
  }),
  mounted: async function () {
    await this.init();
  },
};
</script>
